import { useAccessTokenParam } from '../useAccessTokenParam'
import { useUser } from '../useUser'

/**
 * This is a hook that gets access token from the storage or from the url
 */
export const useAccessToken = () => {
  let accessToken = useAccessTokenParam()
  const { accessToken: localStorageAccessToken } = useUser()

  //if the access token is available from URL search params then use it
  //else use it from the local storage
  accessToken = accessToken ?? localStorageAccessToken

  return accessToken
}
